import AcfHelper from "../../_acf";
import Slider from "../../utils/_slider";
import Breakpoints from "../../utils/_breakpoints";

const blockClass = 'solutions-cards-block';
const slidersClass = 'solutions-cards-slider';

const SolutionsCards = {};

SolutionsCards.blockName = "solutions-cards";

SolutionsCards.init = () => {
    AcfHelper.handleInit(SolutionsCards.blockName, () => {
        Slider.init({
            slider: slidersClass,
            container: blockClass,
        }, {
            // Fractions volontaires : la carte suivante dépasse, ce qui signale
            // qu'on peut faire défiler.
            slidesPerView: 1.1,
            loop: false,
            breakpoints: {
                [Breakpoints.getValues().md]: {
                    slidesPerView: 2.2,
                },
                [Breakpoints.getValues().lg]: {
                    slidesPerView: 3.4,
                }
            }
        });
    });
};

SolutionsCards.init();
export default SolutionsCards;
